import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { Link } from "react-router-dom";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import { courseList } from "../../api/Courses";
import usePrivateLink from "../config/usePrivateLink";
import Master from "./Master";
import { StaffList } from "../../api/Staff";
import { handleEnquiryDownload } from "./components/Master";
import EnquiryTable from "./components/EnquiryTable";

export default function Enquiries() {
  const [loading, setLoading] = useState("");
  const hasAccess = usePrivateLink();
  const [courses, setCourses] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const [filters, setFilters] = useState({ page: 1, status: "" });

  useEffect(() => {
    const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
    setSessions(parseSessions);
  }, []);

  useEffect(() => {
    const activeSession = sessions?.find((s) => Number(s.status) === 1)?.id;
    setFilters((prev) => {
      if (prev.session_id || !activeSession) return prev;
      return {
        ...prev,
        session_id: activeSession,
      };
    });
  }, [sessions]);

  const getCourse = async () => {
    setLoading(true);
    try {
      const response = await courseList();
      if (response.data.status) {
        setCourses(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getStaffList = async () => {
    setLoading(true);
    try {
      const response = await StaffList(`limit=all&status=1`);
      if (response.data.status) {
        setStaffs(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCourse();
    getStaffList();
  }, []);

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid p-4">
                <div className="row">
                  <Master />
                  <div className="col-12">
                    <div className="card p-3 mb-3 shadow-sm border-0">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-3">
                          <div
                            style={{
                              width: 45,
                              height: 45,
                              borderRadius: "12px",
                              background:
                                "linear-gradient(45deg,#185fa5,#4f8cff)",
                              color: "#fff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <i className="ri-list-check-2"></i>
                          </div>

                          <div className="me-auto">
                            <h5 className="m-0 fw-bold">Enquiry List</h5>
                            <small className="text-muted">
                              Manage all enquiries
                            </small>
                          </div>
                        </div>

                        <div className="d-flex align-items-center gap-2 me-4">
                          <div className="d-flex flex-wrap gap-2 align-items-center">
                            {/* STATUS */}
                            {filters.status !== "" && (
                              <span className="badge rounded-pill bg-primary-subtle text-primary px-3 py-2">
                                Status:{" "}
                                {{
                                  0: "Pending",
                                  1: "Admitted",
                                  2: "Other",
                                  4: "Demo",
                                  5: "Visits",
                                }[filters.status] || "All"}
                                <i
                                  className="ri-close-line ms-2 cursor-pointer"
                                  onClick={() =>
                                    setFilters({ ...filters, status: "" })
                                  }
                                ></i>
                              </span>
                            )}

                            {/* SEARCH */}
                            {filters.search && (
                              <span className="badge rounded-pill bg-dark-subtle text-dark px-3 py-2">
                                Search: {filters.search}
                                <i
                                  className="ri-close-line ms-2 cursor-pointer"
                                  onClick={() =>
                                    setFilters({ ...filters, search: "" })
                                  }
                                ></i>
                              </span>
                            )}

                            {/* SESSION */}
                            {filters.session_id && (
                              <span className="badge rounded-pill bg-primary-subtle text-primary px-3 py-2">
                                Session:{" "}
                                {sessions.find(
                                  (s) => s.id == filters.session_id,
                                )?.session || "All"}
                                <i
                                  className="ri-close-line ms-2 cursor-pointer"
                                  onClick={() =>
                                    setFilters({ ...filters, session_id: "" })
                                  }
                                ></i>
                              </span>
                            )}

                            {/* COURSE */}
                            {filters.course_id && (
                              <span className="badge rounded-pill bg-success-subtle text-success px-3 py-2">
                                Course:{" "}
                                {
                                  courses.find((c) => c.id == filters.course_id)
                                    ?.title
                                }
                                <i
                                  className="ri-close-line ms-2 cursor-pointer"
                                  onClick={() =>
                                    setFilters({ ...filters, course_id: "" })
                                  }
                                ></i>
                              </span>
                            )}

                            {/* CREATOR */}
                            {filters.created_by && (
                              <span className="badge rounded-pill bg-warning-subtle text-dark px-3 py-2">
                                Creator:{" "}
                                {
                                  staffs.find((s) => s.id == filters.created_by)
                                    ?.name
                                }
                                <i
                                  className="ri-close-line ms-2 cursor-pointer"
                                  onClick={() =>
                                    setFilters({ ...filters, created_by: "" })
                                  }
                                ></i>
                              </span>
                            )}

                            {/* DATE RANGE */}
                            {filters.start_date && (
                              <span className="badge rounded-pill bg-info-subtle text-info px-3 py-2">
                                From: {filters.start_date}
                                <i
                                  className="ri-close-line ms-2 cursor-pointer"
                                  onClick={() =>
                                    setFilters({ ...filters, start_date: "" })
                                  }
                                ></i>
                              </span>
                            )}

                            {filters.end_date && (
                              <span className="badge rounded-pill bg-info-subtle text-info px-3 py-2">
                                To: {filters.end_date}
                                <i
                                  className="ri-close-line ms-2 cursor-pointer"
                                  onClick={() =>
                                    setFilters({ ...filters, end_date: "" })
                                  }
                                ></i>
                              </span>
                            )}

                            {/* SORT */}
                            {filters.sort_by && (
                              <span className="badge rounded-pill bg-secondary-subtle text-dark px-3 py-2">
                                Sort: {filters.sort_by} ({filters.sort_order})
                                <i
                                  className="ri-close-line ms-2 cursor-pointer"
                                  onClick={() =>
                                    setFilters({
                                      ...filters,
                                      sort_by: "",
                                      sort_order: "",
                                    })
                                  }
                                ></i>
                              </span>
                            )}
                          </div>

                          {hasAccess("/enquiry/add") && (
                            <Link
                              to="/enquiry/add"
                              title="Add New Enquiry"
                              className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center"
                              style={{ width: 40, height: 40 }}
                            >
                              <i className="ri-add-line"></i>
                            </Link>
                          )}

                          <button
                            title="Open Filters"
                            className="btn btn-light border rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#filterCanvas"
                            style={{ width: 40, height: 40 }}
                          >
                            <i className="ri-filter-3-line text-primary"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className=" card my-4">
                      <div className="card-body">
                        <EnquiryTable
                          filters={filters}
                          setFilters={setFilters}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="offcanvas offcanvas-end" tabIndex="-1" id="filterCanvas">
        {/* HEADER */}
        <div className="offcanvas-header">
          <div>
            <h5 className="offcanvas-title mb-0">
              <i className="ri-filter-3-line me-2"></i>
              Filters
            </h5>

            <small className="text-muted">Refine enquiry results</small>
          </div>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
          ></button>
        </div>

        {/* BODY */}
        <div className="offcanvas-body">
          <div className="row g-3">
            {/* STATUS */}
            <div className="col-12 d-flex flex-wrap gap-2">
              {[
                { label: "All", value: "" },
                { label: "Pending", value: "0" },
                { label: "Admitted", value: "1" },
                { label: "Demo Classes", value: "4" },
                { label: "Other", value: "2" },
                { label: "Visits", value: "5" },
              ].map((s, i) => (
                <button
                  key={i}
                  className={
                    filters?.status === s.value
                      ? "btn btn-primary rounded-pill btn-sm"
                      : "btn btn-outline-primary rounded-pill btn-sm"
                  }
                  onClick={() => setFilters({ ...filters, status: s.value })}
                >
                  {s.label}
                </button>
              ))}
            </div>

            {/* SEARCH */}
            <div className="col-sm-12">
              <div className="form-floating form-floating-outline">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by Name, Mobile"
                  value={filters?.search}
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      search: e.target.value.toUpperCase(),
                    })
                  }
                />
                <label>Search</label>
              </div>
            </div>

            {/* SESSION */}
            <div className="col-sm-12">
              <div className="form-floating form-floating-outline">
                <select
                  className="form-select"
                  value={filters?.session_id}
                  onChange={(e) =>
                    setFilters({ ...filters, session_id: e.target.value })
                  }
                >
                  <option value="all">All</option>
                  {sessions?.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.session} : {s.status === "1" ? "Active" : "Inactive"}
                    </option>
                  ))}
                </select>
                <label>Session</label>
              </div>
            </div>

            {/* START DATE */}
            <div className="col-sm-12">
              <div className="form-floating form-floating-outline">
                <input
                  type="date"
                  className="form-control"
                  value={filters?.start_date}
                  onChange={(e) =>
                    setFilters({ ...filters, start_date: e.target.value })
                  }
                />
                <label>Start Date</label>
              </div>
            </div>

            {/* END DATE */}
            <div className="col-sm-12">
              <div className="form-floating form-floating-outline">
                <input
                  type="date"
                  className="form-control"
                  value={filters?.end_date}
                  onChange={(e) =>
                    setFilters({ ...filters, end_date: e.target.value })
                  }
                />
                <label>End Date</label>
              </div>
            </div>

            {/* SOURCE */}
            <div className="col-sm-12">
              <div className="form-floating form-floating-outline">
                <select
                  className="form-select"
                  value={filters?.source}
                  onChange={(e) =>
                    setFilters({ ...filters, source: e.target.value })
                  }
                >
                  <option value="">All</option>
                  <option value="Home Visit">Home Visit</option>
                  <option value="Institute Visit">Institute Visit</option>
                  <option value="School Visit">School Visit</option>
                  <option value="Calling">Calling</option>
                  <option value="Visiting">Visiting</option>
                  <option value="Just Dial">Just Dial</option>
                  <option value="WhatsApp">WhatsApp</option>
                  <option value="Instagram">Instagram</option>
                  <option value="Facebook">Facebook</option>
                  <option value="Website">Website</option>
                  <option value="Friend Reference">Friend Reference</option>
                  <option value="Other">Other</option>
                </select>
                <label>Source</label>
              </div>
            </div>

            {/* CREATOR */}
            <div className="col-sm-12">
              <div className="form-floating form-floating-outline">
                <select
                  className="form-select"
                  value={filters?.created_by}
                  onChange={(e) =>
                    setFilters({ ...filters, created_by: e.target.value })
                  }
                >
                  <option value="">All</option>
                  {staffs?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
                <label>Creator</label>
              </div>
            </div>

            {/* COURSE */}
            <div className="col-sm-12">
              <div className="form-floating form-floating-outline">
                <select
                  className="form-select"
                  value={filters?.course_id}
                  onChange={(e) =>
                    setFilters({ ...filters, course_id: e.target.value })
                  }
                >
                  <option value="">All</option>
                  {courses?.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.title}
                    </option>
                  ))}
                </select>
                <label>Course</label>
              </div>
            </div>

            {/* SORT */}
            <div className="col-sm-12">
              <div className="form-floating form-floating-outline">
                <select
                  className="form-select"
                  value={`${filters?.sort_by || ""}_${filters?.sort_order || ""
                    }`}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val) {
                      const i = val.lastIndexOf("_");
                      setFilters({
                        ...filters,
                        sort_by: val.substring(0, i),
                        sort_order: val.substring(i + 1),
                      });
                    } else {
                      setFilters({ ...filters, sort_by: "", sort_order: "" });
                    }
                  }}
                >
                  <option value="">Default</option>
                  <option value="student_name_asc">Name (A → Z)</option>
                  <option value="student_name_desc">Name (Z → A)</option>
                  <option value="enquiry_no_asc">
                    Enquiry No (Low → High)
                  </option>
                  <option value="enquiry_no_desc">
                    Enquiry No (High → Low)
                  </option>
                </select>
                <label>Sort</label>
              </div>
            </div>

            {/* BUTTONS */}
            <div className="row g-2 mt-3">
              <div className="col-6">
                <button
                  className="btn btn-primary w-100"
                  data-bs-dismiss="offcanvas"
                // onClick={getReport}
                >
                  Apply
                </button>
              </div>

              <div className="col-6">
                <button
                  className="btn btn-outline-danger w-100"
                  onClick={() =>
                    setFilters({
                      status: "",
                      search: "",
                      session_id: "",
                      start_date: "",
                      end_date: "",
                      created_by: "",
                      course_id: "",
                      sort_by: "",
                      sort_order: "",
                    })
                  }
                >
                  Reset
                </button>
              </div>

              {hasAccess("/enquiry/export") && (
                <div className="col-6">
                  <button
                    className="btn btn-success w-100"
                    onClick={() =>
                      handleEnquiryDownload("excel", setLoading, filters)
                    }
                  >
                    <i className="ri-file-excel-2-line me-2"></i> Download
                  </button>
                </div>
              )}

              {hasAccess("/enquiry/print") && (
                <div className="col-6">
                  <button
                    className="btn btn-dark w-100"
                    onClick={() =>
                      handleEnquiryDownload("print", setLoading, filters)
                    }
                  >
                    <i className="ri-printer-line me-2"></i> Print
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
